import Marquee from "react-fast-marquee";
import { Diamond } from "lucide-react";
import { MARQUEE_ITEMS } from "../data/content";

export default function SkillMarquee() {
  return (
    <div data-testid="skill-marquee" className="border-y border-white/5 bg-ink-2/50 py-7">
      <Marquee speed={22} gradient={false} pauseOnHover>
        {MARQUEE_ITEMS.map((item) => (
          <span
            key={item}
            className="mx-7 flex items-center gap-14 whitespace-nowrap font-display text-xl font-semibold text-slate-600 sm:text-2xl"
          >
            {item}
            <Diamond className="h-3 w-3 text-brand/50" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
